import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

const ModalComponent = ({ msg, handleCloseModal }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    setOpen(true);
    setMessage(msg);
  }, [msg]);

  const handleClose = () => {
    setOpen(false);
    handleCloseModal();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberRoundedIcon sx={{ color: '#f59e0b' }} />
          {/* <Typography fontWeight={600}>Heads up</Typography> */}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          size="small"
          sx={{ background: 'black', textTransform: 'none' }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalComponent;
